export const DISPLAY_LOADER = "DISPLAY_LOADER";
export const DISABLED_LOADER = "DISABLED_LOADER";
export const CHECKING_DATA = "CHECKING_DATA";
